module.exports = __webpack_public_path__ + "img/gwrraSeal@2x.3ebe6550.png";